import { StyleSheet } from 'aphrodite';
import {
	backgroundAlt,
	borderOutline,
	brandPrimary,
	brandPrimaryActive,
	titles,
	white,
} from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		gap: 4,
		padding: 8,
		backgroundColor: white,
		borderRadius: 8,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
		border: `1px solid ${borderOutline}`,
		alignItems: 'center',
	},
	button: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 32,
		height: 32,
		padding: 0,
		border: `1px solid ${borderOutline}`,
		borderRadius: 6,
		backgroundColor: white,
		color: titles,
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		':hover:not(:disabled)': {
			backgroundColor: backgroundAlt,
			borderColor: brandPrimary,
			color: brandPrimary,
		},
		':active:not(:disabled)': {
			transform: 'scale(0.95)',
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		':focus': {
			outline: '3px solid rgba(59, 130, 246, 0.4)',
			outlineOffset: 2,
		},
	},
	activeButton: {
		backgroundColor: brandPrimary,
		borderColor: brandPrimary,
		color: white,
		':hover:not(:disabled)': {
			backgroundColor: brandPrimaryActive,
			borderColor: brandPrimaryActive,
			color: white,
		},
	},
	divider: {
		width: 1,
		height: 24,
		backgroundColor: borderOutline,
		marginLeft: 4,
		marginRight: 4,
	},
	infoWrapper: {
		position: 'relative',
	},
});
